module.exports = __webpack_public_path__ + "media/images/common/thickbox_bg-50278324a0b8037d5715f930d6004d5d.png";